import { useDropzone } from 'react-dropzone';
import { Box } from '@mui/material';
import MediaDragDrop from './mediaDragDrop';


export default function FraudDocumentFrontImage({fileUpload}) {

    const onDrop = files => {
        fileUpload(files, 'fraudDocumentFrontImage');
    };

    const {getRootProps, getInputProps} = useDropzone({maxFiles:1, onDrop, 
        accept: {'image/jpeg': ['.jpg'],
                 'image/png': ['.png'],
        }});

    return(
        <Box>
            <Box {...getRootProps()}>
                <input {...getInputProps()} />
                <Box>
                    <MediaDragDrop sx={{width: '295px', height: '300px'}} />
                </Box>
            </Box>
        </Box>
    )
}